// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "mf-site-wide." + {"494":"9d1ce9c863d92a26","715":"be01eb2c6b42e5db"}[chunkId] + ".js";
};